import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { TaskCommentEditor } from './TaskCommentEditor.jsx';
import { useEscapeKey } from '../../../../shared/hooks/useWindowEvent';
import './TaskCommentEditorModal.css';

// Espacio de trabajo expandido para el editor de comentarios de tareas -- Decisión #3 del plan
// (.claude/plans/editor-comentarios-tareas.md): el usuario elige trabajar inline o acá, no es
// una alternativa excluyente. No existe un componente de modal genérico reutilizable en el
// proyecto (cada feature arma el suyo) -- overlay + click-outside-to-close, mismo patrón que
// `AddOpModal.jsx:40`.
export function TaskCommentEditorModal({ isOpen, onClose, translate, ...editorProps }) {
    // 04-enforce.md 4.3 -- suscripción `keydown` compartida en vez de un listener propio.
    useEscapeKey(onClose, isOpen);

    if (!isOpen) return null;

    return createPortal(
        <div className="task-comment-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="task-comment-modal-panel">
                <div className="task-comment-modal-header">
                    <span className="task-comment-modal-title">{translate('comments.workspaceTitle')}</span>
                    <button type="button" className="task-comment-modal-close" onClick={onClose} aria-label={translate('comments.collapseEditor')} title={translate('comments.collapseEditor')}>
                        <X size={16} />
                    </button>
                </div>
                <div className="task-comment-modal-body">
                    <TaskCommentEditor
                        {...editorProps}
                        translate={translate}
                        autoFocus
                        isExpanded
                        onCollapse={onClose}
                        className="task-comment-editor-shell--expanded"
                    />
                </div>
            </div>
        </div>,
        document.body
    );
}
